import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Table, Loader, SectionTitle } from '../components';
import { truncate } from '../utils';
import { fetchProducts, deleteProduct } from '../redux/actions';

const rows = [
  { field: '_id', title: 'ID' },
  { field: 'image', title: 'Product Image' },
  { field: 'productName', title: 'Product Name' },
];

const columns = (arr) => {
  return arr.map((i) => ({
    _id: truncate(i._id, 10),
    productId: i._id,
    productName: i.name,
    image: (
      <div className="flex-shrink-0 h-10 w-10">
        <img
          className="h-10 w-10 rounded-full border border-slate-300"
          src={i.imageSrc}
          alt={i.name}
        />
      </div>
    ),
  }));
};

export default function ManageProducts() {
  const { items } = useSelector((state) => state.products);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProducts());
  }, []);

  return (
    <section className="mt-6 px-6">
      {items ? (
        <>
          <div className="mb-3">
            <SectionTitle label="Manage Products" />
          </div>
          <Table
            rows={rows}
            columns={items?.length > 0 ? columns(items) : []}
            actions={[
              {
                name: 'Delete',
                handleClick: (product) => {
                  dispatch(deleteProduct(product.productId));
                },
                color: 'red',
              },
            ]}
          />
        </>
      ) : (
        <Loader />
      )}
    </section>
  );
}
